// ============================================================
// useCreateStudent Hook
// ============================================================

import { useState } from 'react';
import useStudentStore from '@/store/studentStore';
import { useSchool } from './useSchool';

export function useCreateStudent() {
  const { schoolId } = useSchool();
  const createStudent = useStudentStore((s) => s.createStudent);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mutate = async (data) => {
    setLoading(true);
    setError(null);
    try {
      const res = await createStudent(schoolId, data);
      setLoading(false);
      return res;
    } catch (err) {
      setError(err.message);
      setLoading(false);
      throw err;
    }
  };

  return { mutate, loading, error };
}
